import { getCurrentStorageName, getObjectFromSession, setObjectToSession } from '@/utils/session-utils';

import {
  SET_SELECTED_STATUS,
  SET_SEARCH_TEXT,
  SET_CENTRO_CUSTO,
  SET_DATA_FINAL,
  SET_DATA_INICIAL,
  SET_EMPRESA,
  SET_PRODUTO,
  SET_PROJETO,
  SET_RESPONSAVEL,
  SET_GRUPO,
  SET_SOLICITANTE,
  SET_FORNECEDOR,
  SET_LOCAL_ENTREGA,
  SET_LIST_OPTIONS,
  SET_CURRENT_PAGE,
  SET_FILTER,
  SET_OFFSET,
  SET_CURRENT_SESSION_STATE,
  INIT_STATE,
} from './mutations.type';

import { PREFIX_SESSION_STATE_NAME } from './constants';

export default {
  [SET_SELECTED_STATUS](state, selectedStatus) {
    state.selectedStatus = selectedStatus;
  },
  [SET_SEARCH_TEXT](state, searchText) {
    state.searchText = searchText;
  },
  [SET_EMPRESA](state, empresa) {
    state.empresa = empresa;
  },
  [SET_LOCAL_ENTREGA](state, localEntrega) {
    state.localEntrega = localEntrega;
  },
  [SET_CENTRO_CUSTO](state, centroCusto) {
    state.centroCusto = centroCusto;
  },
  [SET_PRODUTO](state, produto) {
    state.produto = produto;
  },
  [SET_PROJETO](state, projeto) {
    state.projeto = projeto;
  },
  [SET_RESPONSAVEL](state, responsavel) {
    state.responsavel = responsavel;
  },
  [SET_DATA_FINAL](state, dataFinal) {
    state.dataFinal = dataFinal;
  },
  [SET_DATA_INICIAL](state, dataInicial) {
    state.dataInicial = dataInicial;
  },
  [SET_GRUPO](state, grupo) {
    state.grupo = grupo;
  },
  [SET_SOLICITANTE](state, solicitante) {
    state.solicitante = solicitante;
  },
  [SET_FORNECEDOR](state, fornecedor) {
    state.fornecedor = fornecedor;
  },
  [SET_CURRENT_PAGE](state, page) {
    state.listOptions.page = page;
  },
  [SET_FILTER](state, filter) {
    state.listOptions.filter = filter;
  },
  [SET_OFFSET](state, offset) {
    state.listOptions.offset = offset;
  },
  [SET_LIST_OPTIONS](state, listOptions) {
    state.listOptions = listOptions;
  },
  [SET_CURRENT_SESSION_STATE](state, ids) {
    const stateName = getCurrentStorageName(
      PREFIX_SESSION_STATE_NAME,
      ids.idCurrentEntidade,
      ids.idCurrentUser,
    );
    if (stateName) {
      setObjectToSession(stateName, state);
    }
  },
  [INIT_STATE](state, ids) {
    const currentStateName = getCurrentStorageName(
      PREFIX_SESSION_STATE_NAME,
      ids.idCurrentEntidade,
      ids.idCurrentUser,
    );
    const sessionObjectState = getObjectFromSession(currentStateName);

    const selectedStatus = sessionObjectState?.selectedStatus || state.selectedStatus;
    state.selectedStatus = state.statusOptions.find(s => s.id === selectedStatus?.id)
      || state.statusOptions[0];
    state.searchText = sessionObjectState?.searchText || state.searchText;
    state.empresa = sessionObjectState?.empresa || state.empresa;
    state.localEntrega = sessionObjectState?.localEntrega || state.localEntrega;
    state.centroCusto = sessionObjectState?.centroCusto || state.centroCusto;
    state.produto = sessionObjectState?.produto || state.produto;
    state.projeto = sessionObjectState?.projeto || state.projeto;
    state.responsavel = sessionObjectState?.responsavel || state.responsavel;
    state.fornecedor = sessionObjectState?.fornecedor || state.fornecedor;
    state.dataFinal = sessionObjectState?.dataFinal || state.dataFinal;
    state.dataInicial = sessionObjectState?.dataInticial || state.dataInticial;
    state.grupo = sessionObjectState?.grupo || state.grupo;
    state.solicitante = sessionObjectState?.solicitante || state.solicitante;
    state.fornecedor = sessionObjectState?.fornecedor || state.fornecedor;
    state.listOptions = sessionObjectState?.listOptions || state.listOptions;
  },
};
